# Specification

Specification section of the docs gives concrete way of how the library public and internal things work.
If you wish to study it and find other use-cases/applications of the behavior, propose new behavior or find bugs - you're so welcome to it.

It's based on the tests with a bit of description and inferred types
